import React from 'react';

export default function ChartMeta({ maxValue, minValue }) {
  return (
    <>
      <div className="absolute -top-[12px] left-0 text-gray-500 dark:text-muted-foreground text-sm select-none">
        {maxValue}
      </div>
      <div className="absolute bottom-[34px] left-0 text-gray-500 dark:text-muted-foreground text-sm select-none">
        {minValue}
      </div>

      <div className="absolute bottom-[29px] left-0 bg-gray-100 dark:bg-muted w-full h-0.5" />
    </>
  );
}
